import Auth from '@aws-amplify/auth';
import Amplify from '@aws-amplify/core';
import awsExportFactory from '../aws-exports';
import getEnv from '../service/getEnv';

console.log('getEnv', getEnv());

Amplify.configure(awsExportFactory(getEnv()));

export {Auth};